<template>
  <div>
    <i title="Remover dos prioritários" class="fas fa-star text-warning" @click.prevent="updateCheck(false)"
      v-if="checked"></i>
    <i class="far fa-star" title="Adicionar como prioriotário" @click.prevent="updateCheck(true)" v-else></i>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return { value: null }
  },
  props: {
    id: Number,
    checked: Boolean,
    route: String,
  },
  methods: {
    ...mapMutations("datatable", ["setReload"]),

    async updateCheck() {
      await this.$api.put(this.route, {
        id: this.id,
        value: 1,
      });
      this.setReload();
    },
  },
};
</script>

<style>
.fa-star {
  cursor: pointer;
}
</style>